export const sundayUppercase = "rra";
export default {sundayUppercase};